import type React from "react"

export const Books: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="16"
    x="-1px"
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Books</title>
    <path d="M15.9375 14.125L12.5625 1.625C12.375 0.96875 11.7812 0.5 11.125 0.5C11 0.5 10.875 0.53125 10.7188 0.5625L8.8125 1.09375C8.625 1.125 8.4375 1.21875 8.3125 1.3125C8.0625 0.84375 7.5625 0.5 7 0.5H5C4.71875 0.5 4.46875 0.59375 4.25 0.71875C4 0.59375 3.75 0.5 3.5 0.5H1.5C0.65625 0.5 0 1.1875 0 2V15C0 15.8438 0.65625 16.5 1.5 16.5H3.5C3.75 16.5 4 16.4375 4.25 16.3125C4.46875 16.4375 4.71875 16.5 5 16.5H7C7.8125 16.5 8.5 15.8438 8.5 15V5.6875L11.0938 15.4062C11.2812 16.0625 11.875 16.5 12.5625 16.5C12.6875 16.5 12.8125 16.5 12.9375 16.4688L14.875 15.9375C15.6875 15.7188 16.1562 14.9062 15.9375 14.125ZM7 2V3.5H5V2H7ZM5 5H7V12H5V5ZM3.5 12H1.5V5H3.5V12ZM3.5 2V3.5H1.5V2H3.5ZM1.5 15V13.5H3.5V15H1.5ZM5 15V13.5312L7 13.5V15H5ZM9.1875 2.53125L11.125 2.03125L11.5 3.4375L9.5625 3.96875L9.1875 2.53125ZM9.96875 5.40625L11.9062 4.90625L13.7188 11.625L11.7812 12.125L9.96875 5.40625ZM12.5625 15.0312L12.1562 13.5938L14.0938 13.0625L14.5 14.5L12.5625 15.0312Z" />
  </svg>
)
